// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './pages/Home';
import PhotoGallery from './components/GetPhotosClient';
import ContactWithRecaptcha from './components/ContactRecaptcha';

const App: React.FC = () => {
  return (
      <Router>
        {/* Navigation */}
        <header className="bg-[#0c6081] text-white shadow-lg">
          <nav className="container mx-auto p-4 flex justify-between">
            <div className="text-xl font-semibold">Daytocode</div>
            <ul className="flex space-x-4">
              <li>
                <Link to="/" className="hover:text-[#f7b95d]">Home</Link>
              </li>                     
              <li>
                <Link to="/photos" className="hover:text-[#f7b95d]">Photos</Link>
              </li>           
              <li>
                <Link to="/contact" className="hover:text-[#f7b95d]">Contact Us</Link>
              </li>
            </ul>
          </nav>
        </header>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />        
          <Route path="/photos" element={<PhotoGallery />} />
          <Route path="/contact" element={<ContactWithRecaptcha />} />      
        </Routes>
      </Router>
  );
};

export default App;
